export default class HttpResponse {
  constructor(public data?: any, public error?: string) {}
}
